import InvitationsContent from './InvitationsContent';

const Invitations = () => {
  return <InvitationsContent />;
};

export default Invitations;
